export const english = {
  lang: 'en',
  data: {
    ADMIN: {
      BLOCK: 'Block administration',
      DELETE: 'Remove administration',
      LEDGER: 'View administration',
      LOGIN: 'Login to this administration',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/i18n/en.ts